'use client';

import Image, { ImageProps } from 'next/image';
import React, { useState } from 'react';

import { cn } from '../helpers/cn';

const ImageWithTransition = React.forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <Image
            {...props}
            className={cn(props.className, !isLoaded && 'opacity-0', 'duration-[500ms]')}
            onLoad={(event) => {
                setIsLoaded(true);
                props.onLoad?.(event);
            }}
            alt={props.alt}
            ref={ref}
        />
    );
});

ImageWithTransition.displayName = 'ImageWithTransition';

export default ImageWithTransition;
